import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { AttendenceExportService } from './attendance-export.service';
import { Observable, tap } from 'rxjs';

@Component({
  selector: 'app-attendance-export',
  standalone: false,
  templateUrl: './attendance-export.component.html',
  styleUrls: ['./attendance-export.component.scss']
})
export class AttendanceExportComponent implements OnInit {
  currentUI: string = 'validate-payroll-code';
  proceedApiResponse: any;
  attendanceHeader: any;
  selectedPayrollGroup: string = '2';
  selectedYear: string = '2025';
  selectedWeek: string = '32';

  constructor(
    private attendanceExportService: AttendenceExportService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    console.log('AttendanceExportComponent initialized, currentUI:', this.currentUI);
  }

  onValidatePayrollCodeProceed(event: any) {
    const { payload, header } = event;
    this.attendanceHeader = header;

    console.log('=== PROCEED CLICKED ===');
    console.log('Current UI before API:', this.currentUI);
    console.log('Calling first API with payload:', payload);
    console.log('Header:', header);

    // Call first API - proceedChecking
    this.attendanceExportService.proceedChecking(payload).subscribe({
      next: (response) => {
        console.log('First API response:', response);
        console.log('Response status:', response.status);
        console.log('Response data:', response.data);
        
        if (response.status === 'SUCCESS') {
          const employeeAttendance = response.data?.employee_attendance || [];
          console.log('Employee attendance count:', employeeAttendance.length);
          
          if (employeeAttendance.length > 0) {
            // Data exists: Go to validation UI
            this.proceedApiResponse = {
              ...response,
              attendanceHeader: header // Include header in the response
            };
            console.log('Changing UI to: validate-attendance-inout');
            this.currentUI = 'validate-attendance-inout';
            console.log('UI changed to:', this.currentUI);
            this.cdr.detectChanges();
          } else {
            // No data: Call second API for attendance hour check
            console.log('No attendance data, calling export API');
            this.callExportAttendanceAPI(payload).subscribe();
          }
        } else {
          console.error('First API failed:', response.message);
          this.currentUI = 'validate-payroll-code'; // Stay on same page
        }
      },
      error: (err) => {
        console.error('Error in proceedChecking:', err);
        this.currentUI = 'validate-payroll-code';
      }
    });
  }

  callExportAttendanceAPI(payload: any): Observable<any> {
    console.log('=== EXPORT ATTENDANCE API CALL ===');
    console.log('Export API payload:', payload);
    return this.attendanceExportService.exportAttendance(payload).pipe(
      tap(response => {
        console.log('=== EXPORT ATTENDANCE API RESPONSE ===');
        console.log('Second API response:', response);
        console.log('Response status:', response.status);
        console.log('Response data:', response.data);
        
        if (response.status === 'SUCCESS') {
          const exportData = response.data?.employee_attendance_export || [];
          console.log('Export data length:', exportData.length);
          this.proceedApiResponse = {
            ...response,
            attendanceHeader: this.attendanceHeader // Include header in the response
          };
          
          if (exportData.length > 0) {
            // Data exists: Go to hour limit validation
            console.log('Export data found, going to validate-attendance-limit');
            this.currentUI = 'validate-attendance-limit';
            console.log('currentUI set to:', this.currentUI);
            this.cdr.detectChanges();
          } else {
            // No data: Go directly to export
            console.log('No export data, going to attendance-data-export');
            this.currentUI = 'attendance-data-export';
            this.cdr.detectChanges();
          }
        } else {
          console.error('Export API failed:', response.message);
          this.currentUI = 'validate-payroll-code';
        }
      })
    );
  }

  onValidateAttendanceInoutProceed() {
    // Call export API to get hour limit data
    const payload = {
      payroll_group_id: this.proceedApiResponse?.data?.payroll_group_id || this.attendanceHeader?.payroll_group_id,
      year: this.proceedApiResponse?.data?.year || this.attendanceHeader?.year,
      weekNo: this.proceedApiResponse?.data?.weekNo || this.attendanceHeader?.weekNo
    };

    console.log('=== ATTENDANCE INOUT PROCEED CLICKED ===');
    console.log('Calling export API from attendance-inout with payload:', payload);
    console.log('Current proceedApiResponse before API call:', this.proceedApiResponse);
    this.callExportAttendanceAPI(payload).subscribe();
  }

  onValidateAttendanceInoutBack() {
    this.currentUI = 'validate-payroll-code';
  }

  onValidateAttendanceLimitProceed() {
    this.currentUI = 'attendance-data-export';
  }

  onValidateAttendanceLimitBack() {
    this.currentUI = 'validate-payroll-code';
  }

  onExportAttendanceProceed() {
    // TODO: Handle final export logic
    console.log('onExportAttendanceProceed called');
  }

  onExportAttendanceBack() {
    this.currentUI = 'validate-payroll-code';
  }

  // Add these new methods
  testProceed() {
    const mockEvent = {
      payload: { payroll_group_id: 2, year: 2025, weekNo: 32 },
      header: { payroll_group_code: 'AU', payroll_group_id: 2, year: 2025, weekNo: 32 }
    };
    this.onValidatePayrollCodeProceed(mockEvent);
  }

  getCurrentTitle() {
    switch(this.currentUI) {
      case 'validate-attendance-inout': return 'Validate Attendance In/Out';
      case 'validate-attendance-limit': return 'Validate Attendance Hour Limit';  
      case 'attendance-data-export': return 'Attendance Data Export';
      default: return 'Unknown State';
    }
  }

  handleProceed() {
    switch(this.currentUI) {
      case 'validate-attendance-inout':
        this.onValidateAttendanceInoutProceed();
        break;
      case 'validate-attendance-limit':
        this.onValidateAttendanceLimitProceed();
        break;
      case 'attendance-data-export':
        this.onExportAttendanceProceed();
        break;
    }
  }

  handleBack() {
    switch(this.currentUI) {
      case 'validate-attendance-inout':
        this.onValidateAttendanceInoutBack();
        break;
      case 'validate-attendance-limit':
        this.onValidateAttendanceLimitBack();
        break;
      case 'attendance-data-export':
        this.onExportAttendanceBack();
        break;
    }
  }

  proceedWithSelection() {
    const payload = {
      payroll_group_id: parseInt(this.selectedPayrollGroup),
      year: parseInt(this.selectedYear),
      weekNo: parseInt(this.selectedWeek)
    };
    
    const header = {
      payroll_group_code: this.getPayrollGroupCode(this.selectedPayrollGroup),
      payroll_group_id: parseInt(this.selectedPayrollGroup),
      year: parseInt(this.selectedYear),
      weekNo: parseInt(this.selectedWeek),
      period: '2025-26'
    };

    const event = { payload, header };
    this.onValidatePayrollCodeProceed(event);
  }

  getPayrollGroupCode(id: string): string {
    const codes: any = { '2': 'AU', '3': 'WE', '4': 'CH' };
    return codes[id] || 'AU';
  }
}
